import { BrandLoyaltyConfiguration } from '../configuration/BrandLoyaltyConfiguration';
import { type Location } from './Location';
import { BrandType } from '../enums/BrandType.ts';


export interface Brand {
    id?: string;
    organizationId: string;
    name: string;
    slug?: string;
    type: BrandType;
    timeZoneId?: string;
    onboardingEmail?: string | null;
    locations?: Location[];
    loyaltyConfiguration?: BrandLoyaltyConfiguration | undefined | null;
    touchTabFeedbackEnabled?: boolean;

    /**
     * The languages this brand operates in, BCP-47. Constrains which locales a LOCATION of this brand may be
     * set to, and which languages the content-strings screen offers.
     *
     * en-US is deliberately not implied - it stays the last step of the content-string fallback chain, so a
     * brand operating only in Quebec declares fr-CA and still gets the English default underneath.
     */
    supportedLocales?: string[];
}

export function createBrand(organizationId: string): Brand {
    return {
        id: undefined,
        type: 0,
        organizationId: organizationId,        
        name: '',
        slug: undefined,
        onboardingEmail: null,
        locations: [],
        loyaltyConfiguration: undefined,
        touchTabFeedbackEnabled: false,
        supportedLocales: []
    };
}